<template>
  <div class="app bg">
    <CustomerHeader/>
    <div class="app-body">
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <DefaultFooter/>
  </div>
</template>

<script>
import { SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Breadcrumb } from '@coreui/vue'
import CustomerHeader from './CustomerHeader'
import DefaultFooter from './DefaultFooter'
import { mapGetters , mapState} from "vuex";

export default {
  name: 'DefaultContainer',
  components: {
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    CustomerHeader
  },
  data () {
    return {
    }
  },
  methods:{
    parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return jsonPayload;
    }
  },
  computed: {
      ...mapGetters("login", ["loggedIn"]),
      ...mapState("login", ["access_token"])
  }
}
</script>

<style scoped>
.bg {
    /* The image used for web */
    background: url("~@/assets/bcg-image.jpg");

    /* Full height */
    height: 100vh;
    overflow-y: auto;
    /* Center and scale the image nicely */
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
</style>
